import {
	Card,
	CardContent,
	Typography,
	FormControl,
	FormControlLabel,
	Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
	imageFolder
} from "../../constants/ImageConstants";
import "./style.scss";
import PropTypes from 'prop-types'
/* istanbul ignore next */
const CurrencyComponent = (props) => {
	/* istanbul ignore next */
	const { t: getLabel } = useTranslation();
	return (
		<FormControl id={`fxcm-currency-option-${props.currency}`} className="currency-form-controlar" sx={{ mb: 1 }}>
			<FormControlLabel
				value={props.currency}
				control={<Radio id={`fxcm-currency-radio-${props.currency}`} />}
				label={
					<Card data-testid="currencyCard" id={`fxcm-currency-card-${props.currency}`}>
						<CardContent id={`fxcm-currency-content-${props.currency}`}>
							<img src={`${imageFolder}${props.icon}.png`} alt="icon" id={`fxcm-currency-img-${props.currency}`}/>
							<Typography data-testid="currencyCardLabel" id={`fxcm-currency-label-${props.currency}`}>
								{getLabel(props.currency)} <small>{getLabel(props.currencySub)}</small>
							</Typography>
						</CardContent>
					</Card>
				}
			/>
		</FormControl>
	);
};
CurrencyComponent.propTypes = {
  currency: PropTypes.string.isRequired,
  currencySub: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
}

export default CurrencyComponent;
